import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'delcoma'
})
export class DelcomaPipe implements PipeTransform {

  transform(valor: string): string {
    const newValor = valor.replace(',', '');
    return newValor;
  }

}
